// src/contexts/NotificationProvider.jsx (componente proveedor)
import React, { useState, useCallback } from 'react';
import { Snackbar, Alert } from '@mui/material';
import NotificationContext from '@/contexts/notificationContext';

const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info' // 'error', 'warning', 'info', 'success'
  });

  const showNotification = useCallback((messageOrOptions, severity = 'info') => {
    // Manejar tanto objetos como parámetros separados
    let message, finalSeverity;
    
    if (typeof messageOrOptions === 'object' && messageOrOptions !== null) {
      // Formato: showNotification({type: 'success', message: 'texto'})
      message = messageOrOptions.message;
      finalSeverity = messageOrOptions.type || messageOrOptions.severity || 'info';
    } else {
      // Formato: showNotification('texto', 'success')
      message = messageOrOptions;
      finalSeverity = severity;
    }
    
    // Validación adicional
    if (!message || typeof message !== 'string') {
      console.warn('showNotification: mensaje inválido:', messageOrOptions);
      message = 'Notificación';
    }
    
    setNotification({
      open: true,
      message,
      severity: finalSeverity
    });
  }, []);

  const hideNotification = () => {
    setNotification(prev => ({ ...prev, open: false }));
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={6000}
        onClose={hideNotification}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={hideNotification} severity={notification.severity}>
          {typeof notification.message === 'string' ? notification.message : 'Notificación'}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export default NotificationProvider;